<template>
  <div class="row">
    <div class="col">
      <b-calendar
        :value="dateVal"
        @input="updateDate"
        name="date"
        block
        locale="en-US"
      ></b-calendar>
    </div>
    <div class="col-3" v-if="dateVal">
      <b-time
        :value="timeVal"
        @input="updateTime"
        name="time"
        hour12
        nolabel
        minutes-step="15"
        :form-state="formState"
      >
      </b-time>
      <div class="pt-5">
        <b-button variant="danger" block @click="clear">Clear</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import FormComponentMixin from "@/vue-ocom/mixins/form_component_mixin";

export default {
  name: "DateTimePicker",
  mixins: [FormComponentMixin],
  data() {
    return {
      timeVal: "",
      dateVal: "",
    };
  },
  model: {
    value: "value",
    event: "input",
  },
  props: {
    value: { type: [String, Date] },
    timezone: { type: String, default: "Australia/Melbourne" },
  },
  methods: {
    updateDate(value) {
      if (this.dateVal !== value) {
        this.dateVal = value;
        this.notify_changed();
      }
    },
    updateTime(value) {
      if (this.timeVal !== value) {
        this.timeVal = value;
        this.notify_changed();
      }
    },
    clear() {
      this.dateVal = "";
      this.timeVal = "";

      this.notify_changed();
    },
    notify_changed() {
      if (!this.dateVal && !this.timeVal) {
        this.on_change(null);
        return;
      }

      if (!this.timeVal) {
        // At local midnight
        this.timeVal = moment()
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .tz(this.timezone)
          .format("HH:mm:ss");
      }

      var newValueStr = this.dateVal + "T" + this.timeVal;
      var newValue = moment
        .tz(newValueStr, this.timezone) // Process as Local time
        .utc() // Return a UTC value!
        .toISOString(); // Convert to ISO string..

      // Notify the v-model the full date and time value!
      this.on_change(newValue);
    },
    update_internal_values(value) {
      // update the dateVal and timeVal using the value passed in
      if (value == null || value === "") {
        this.dateVal = "";
        this.timeVal = "";
      } else {
        // Get local moment.
        var m = moment.tz(value, this.timezone);

        if (!m.isValid()) {
          //invalid - assume today??
          m = moment(moment().toISOString().split("T")[0]);
        }

        this.dateVal = m.format("YYYY-MM-DD");
        this.timeVal = m.format("HH:mm:ss"); // as the b-time expects
      }
    },
  },
  watch: {
    value(new_val, old_val) {
      this.update_internal_values(new_val);
    },
  },
  mounted() {
    //ensure the dateVal and timeVal are correct.
    this.update_internal_values(this.value);
  },
};
</script>

<style scoped></style>
